var getBaseUrl = function getBaseUrl(hostEnv) {
  if (hostEnv === 'qa') {
    return 'https://qa-beta.theknot.com/';
  } else if (hostEnv === 'production') {
    return 'https://www.theknot.com/';
  }
  return '/';
};
var generateFormLinks = function generateFormLinks() {
  var hostEnv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : process.env.UNION_DEPLOYMENT_ENV;
  var withHost = function withHost(relUrl) {
    return "".concat(getBaseUrl(hostEnv)).concat(relUrl);
  };
  return {
    FORGOT_PASSWORD: withHost('account/forgot-password/provide-email'),
    PRIVACY_POLICY: withHost('privacy-policy'),
    TERMS_AND_CONDITIONS: withHost('terms-and-conditions')
  };
};
export default generateFormLinks;